import { type BranchOption, type ResolvedBranchNode } from '@/lib/branchTypes'

// Builds the grid track sizes; primary option keeps natural width unless we're laid out for the expanded plan view.
export const getOptionsGridTemplateColumns = (
  options: BranchOption[],
  nodes: Record<string, ResolvedBranchNode>,
  expandedPlanLayout: boolean,
): string => {
  return options
    .map(o => {
      const optionIsPrimary = o.primary || (o.targetId && nodes[o.targetId]?.primary)
      if (!optionIsPrimary) return '1fr'
      return expandedPlanLayout ? '1fr' : 'auto'
    })
    .join(' ')
}
